import React from 'react';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
export const BroadbandIcon = (props) => {
    const { serviceID, value } = props;
    const classes = commonStyle();
    let colorNonSelected = classes.svg_non_selected;
    let colorSelected = classes.svg_selected;
    if (serviceID !== value) {
        colorSelected = classes.svg_non_selected;
    }

    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style={{ enableBackground: 'new 0 0 512 512' }}
        >
            <g>
                <g>
                    <path
                        className={colorNonSelected}
                        d="M458.7,301.2H53.3c-29.4,0-53.3,24-53.3,53.4v42.7c0,29.4,23.9,53.3,53.3,53.3h405.3
			c29.4,0,53.3-23.9,53.3-53.3v-42.7C512,325.2,488.1,301.2,458.7,301.2z M490.7,397.2c0,17.6-14.4,32-32,32H53.3
			c-17.6,0-32-14.4-32-32v-42.7c0-17.6,14.4-32,32-32h405.3c17.6,0,32,14.4,32,32L490.7,397.2L490.7,397.2z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorNonSelected}
                        d="M373.3,151.9c-5.9,0-10.7,4.8-10.7,10.7v149.3c0,5.9,4.8,10.7,10.7,10.7s10.7-4.8,10.7-10.7V162.6
			C384,156.7,379.2,151.9,373.3,151.9z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <ellipse
                        transform="matrix(3.327796e-02 -0.9994 0.9994 3.327796e-02 -303.4777 438.0494)"
                        className={colorNonSelected}
                        cx="74.7"
                        cy="375.9"
                        rx="10.7"
                        ry="10.7"
                    />
                </g>
            </g>
            <g>
                <g>
                    <circle
                        className={colorNonSelected}
                        cx="138.7"
                        cy="375.9"
                        r="10.7"
                    />
                </g>
            </g>
            <g>
                <g>
                    <circle
                        className={colorNonSelected}
                        cx="202.7"
                        cy="375.9"
                        r="10.7"
                    />
                </g>
            </g>
            <g>
                <g>
                    <circle
                        className={colorNonSelected}
                        cx="266.7"
                        cy="375.9"
                        r="10.7"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M437.3,365.2H330.7c-5.9,0-10.7,4.8-10.7,10.7s4.8,10.7,10.7,10.7h106.7c5.9,0,10.7-4.8,10.7-10.7
			C448,370,443.2,365.2,437.3,365.2z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M341.3,162.6c0-8.6,3.3-16.6,9.4-22.6c4.2-4.2,4.2-10.9,0-15.1s-10.9-4.2-15.1,0
			C325.5,135,320,148.4,320,162.6c0,14.3,5.5,27.6,15.6,37.7c2.1,2.1,4.8,3.1,7.6,3.1s5.5-1,7.5-3.1c4.2-4.2,4.2-10.9,0-15.1
			C344.7,179.1,341.3,171.1,341.3,162.6z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M411.1,124.9c-4.2-4.2-10.9-4.2-15.1,0c-4.2,4.2-4.2,10.9,0,15.1c6,6.1,9.4,14.1,9.4,22.6
			c0,8.6-3.3,16.6-9.4,22.6c-4.2,4.2-4.2,10.9,0,15.1c2.1,2.1,4.8,3.1,7.6,3.1s5.5-1,7.6-3.1c10.1-10.1,15.6-23.5,15.6-37.7
			C426.7,148.3,421.1,134.9,411.1,124.9z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M320.5,109.8c4.2-4.2,4.2-10.9,0-15.1s-10.9-4.2-15.1,0c-37.4,37.4-37.4,98.3,0,135.8
			c2.1,2.1,4.8,3.1,7.6,3.1s5.5-1,7.5-3.1c4.2-4.2,4.2-10.9,0-15.1C291.4,186.3,291.4,138.9,320.5,109.8z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M441.2,94.7c-4.2-4.2-10.9-4.2-15.1,0s-4.2,10.9,0,15.1c29.1,29.1,29.1,76.5,0,105.6
			c-4.2,4.2-4.2,10.9,0,15.1c2.1,2.1,4.8,3.1,7.6,3.1s5.4-1,7.5-3.1C478.6,193,478.6,132.2,441.2,94.7z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M290.3,79.6c4.2-4.2,4.2-10.9,0-15.1s-10.9-4.2-15.1,0c-54.1,54.1-54.1,142,0,196.1c2.1,2.1,4.8,3.1,7.6,3.1
			s5.5-1,7.5-3.1c4.2-4.2,4.2-10.9,0-15.1C244.6,199.8,244.6,125.4,290.3,79.6z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        className={colorSelected}
                        d="M471.4,64.5c-4.2-4.2-10.9-4.2-15.1,0s-4.2,10.9,0,15.1c45.8,45.7,45.8,120.2,0,165.9
			c-4.2,4.2-4.2,10.9,0,15.1c2.1,2.1,4.8,3.1,7.6,3.1s5.5-1,7.5-3.1C525.4,206.6,525.4,118.6,471.4,64.5z"
                    />
                </g>
            </g>
        </svg>
    );
};
